<template>
  <v-list>
    <v-subheader
      >Filtrar por
      <span class="font-weight-bold ml-1 primary--text"
        >RELEVÂNCIA</span
      ></v-subheader
    >
    <v-list-item-group v-model="selectedItem" color="primary">
      <v-list-item v-for="(item, i) in items" :key="i">
        <v-list-item-content>
          <v-list-item-title v-text="item.text"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>
<script>
export default {
  data() {
    return {
      selectedItem: null,
      items: [
        { text: "MAIS RELEVANTES", icon: "mdi-clock", count: 2257 },
        { text: "MAIS RECENTES", icon: "mdi-account", count: 189 },
        { text: "MAIS ANTIGOS", icon: "mdi-flag", count: 984 }
      ]
    };
  }
};
</script>
